import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';
import { toursApiQueryKeys } from '@/features/dashboard/tours/api/toursApi.queryKeys.ts';
import toursApi from '@/features/dashboard/tours/api/toursApi.ts';

const useOpenRegistration = () => {
  const queryClient = useQueryClient();

  return useMutation<void, Error, string>({
    mutationFn: (tourId) => toursApi.openRegistration(tourId),
    onSuccess: (_, tourId) => {
      toast.success('Rejestracja została otwarta');
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.all(),
      });
      queryClient.invalidateQueries({
        queryKey: toursApiQueryKeys.byId(tourId),
      });
    },
    onError: (error: Error) => {
      toast.error('Nie udało się otworzyć rejestracji', {
        description: error.message,
      });
    },
  });
};

export default useOpenRegistration;
